import React, { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";
import { Tooltip } from "@heroui/tooltip";
import { Loader2 } from "lucide-react";
interface CopyTripProps {
  onCopy: () => void;
  isLoading: boolean;
  isCopied: boolean;
  setIsCopied: (isCopied: boolean) => void;
}

const CopyTrip: React.FC<CopyTripProps> = ({
  onCopy,
  isLoading,
  isCopied,
  setIsCopied,
}) => {
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (isCopied) {
      timeout = setTimeout(() => setIsCopied(false), 2000);
    }
    return () => clearTimeout(timeout);
  }, [isCopied, setIsCopied]);

  return (
    <Tooltip
      content={<p className="text-xs font-font-light">Copy trip</p>}
      placement="bottom"
      showArrow
      delay={250}
    >
      <button
        className="flex flex-row text-xs space-x-2 items-center h-8 px-3 hover:opacity-90 bg-indigo-700 text-indigo-50 rounded-full focus:ring-0 focus-visible:ring-transparent transition-all duration-300 ease-in-out"
        onClick={onCopy}
      >
        {isLoading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : isCopied ? (
          <Check className="w-4 h-4" />
        ) : (
          <Copy className="w-4 h-4" />
        )}
        <p className="font-normal">Copy</p>
      </button>
    </Tooltip>
  );
};

export default CopyTrip;
